<template>
  <div>
    <v-btn elevation="8" icon style="background: white; position: absolute; left: 10px; top: 10px; z-index: 99" @click="goBack()"><v-icon>mdi-chevron-left</v-icon></v-btn>

    <v-container style="background: rgba(0, 0, 0, 0.6); height: 400px; width: 100%; position: absolute; z-index: 80; text-align: center" fill-height fluid v-if="showLoading">
      <v-row align="center" justify="center">
        <v-col>
          <v-progress-circular :size="40" color="white" indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
    <MglMap
      container="map-test"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      style="height: 400px"
      @load="onMapLoaded"
      :interactive="interactive"
      maxPitch="0"
      minPitch="0"
      logoPosition="bottom-left"
      :dragRotate="rotate"
      :maxZoom.sync="maxZoom"
      :minZoom.sync="minZoom"
    >
      <MglGeojsonLayer :sourceId="parkingsSourceId" :source="geoJsonSourceParkings" :layerId="parkingsLayerId" :layer="geoJsonLayerParkings" @click="parkingSelected" />
      <MglGeojsonLayer :sourceId="destinationsSourceId" :source="geoJsonSourceDestinations" :layerId="destinationsLayerId" :layer="geoJsonLayerDestinations" />
      <MglGeojsonLayer :sourceId="lineSourceId" :source="geoJsonSourceLine" :layerId="lineLayerId" :layer="geoJsonLayerLine" />
      <MglGeojsonLayer :sourceId="freeSpotSourceId" :source="geoJsonSourceFreeSpot" :layerId="freeSpotBorderLayerId" :layer="geoJsonLayerFreeSpotBorder" />
      <MglGeojsonLayer :sourceId="freeSpotSourceId" :source="geoJsonSourceFreeSpot" :layerId="freeSpotLayerId" :layer="geoJsonLayerFreeSpot" />
    </MglMap>
    <div v-if="current_parking !== undefined && !showLoading" style="position: relative">
      <div style="margin: auto; width: 100%; position: absolute; top: -35px">
        <div class="mt-2 mb-1 justify-center" style="margin: auto">
          <v-img max-width="50px" :src="`${config.FRONT.PATH}/${current_site._id}-${current_parking.name}.png`" style="margin: auto"> </v-img>
        </div>
      </div>
    </div>
    <v-card-text class="mt-5">
      <div v-if="current_spot !== undefined && !showLoading" transition="slide-y-reverse-transition">
        <div style="margin: auto; width: 100%; text-align: center">
          <v-chip v-if="current_spot.meta_data.parking.aisle !== current_parking.name" label :style="`font-size: 1.2em; color: white; background: ${current_parking.fill_color};`"
            >{{ $t('find_best_spot.aisle') }} {{ current_spot.meta_data.parking.aisle }}</v-chip
          >
        </div>
        <v-row class="mt-1" no-gutters v-if="current_spot.driving_duration !== null && current_spot.walking_duration !== null && current_spot.walking_calories !== null">
          <v-col>
            <v-icon class="my-3">mdi-car</v-icon> {{ Math.ceil(current_spot.driving_duration / 60) }} {{ $t('min') }}
            <v-tooltip bottom v-if="!location">
              <template v-slot:activator="{ on }">
                <v-icon small class="my-3" v-on="on">mdi-information</v-icon>
              </template>
              <template v-slot:default>{{ $t('sitedetails.driving_time_infos') }}</template>
            </v-tooltip>
          </v-col>
          <v-col style="text-align: center"> <v-icon class="my-3"> mdi-walk</v-icon> {{ Math.ceil(current_spot.walking_duration / 60) }} {{ $t('min') }} </v-col>
          <v-col style="text-align: right"> <v-icon class="my-3"> mdi-fire</v-icon> {{ parseInt(current_spot.walking_calories / 1000) }} {{ $t('kcal') }}</v-col>
        </v-row>
        <div style="margin: auto; width: 100%; text-align: center">
          <em style="font-size: 0.9em; line-height: 1.2em">{{ $t('find_best_spot.guid_by_signs') }}</em>
        </div>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { MglMap, MglGeojsonLayer } from 'vue-mapbox';

import { Config } from '@/config';

export default {
  name: 'App',
  components: {
    MglMap,
    MglGeojsonLayer,
  },
  data() {
    return {
      showLoading: true,
      config: Config,

      // MAPBOX config
      center: null,
      zoom: null,
      minZoom: Config.MAPBOX.MIN_ZOOM,
      maxZoom: Config.MAPBOX.MAX_ZOOM,
      rotate: false,
      accessToken: Config.MAPBOX.TOKEN,
      mapStyle: 'mapbox://styles/tibeoh/ckgtx9fjj0xes19nokhtk60rf',
      interactive: true,

      //MAPBOX destinations
      destinationsSourceId: 'destinationsSourceId',
      geoJsonSourceDestinations: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      destinationsLayerId: 'destinationsLayerId',
      geoJsonLayerDestinations: {
        id: 'destinationsLayerId',
        type: 'fill',
        paint: {
          'fill-color': {
            type: 'identity',
            property: 'fillcolor',
          },
          'fill-opacity': 0.2,
        },
      },

      //MAPBOX parkings
      parkingsSourceId: 'parkingsSourceId',
      geoJsonSourceParkings: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      parkingsLayerId: 'parkingsLayerId',
      geoJsonLayerParkings: {
        id: 'parkingsLayerId',
        type: 'fill',
        paint: {
          'fill-color': {
            type: 'identity',
            property: 'fillcolor',
          },
          'fill-outline-color': 'rgba(255,255,255, 1)',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'click'], false], 1, 0.5],
        },
      },

      //MAPBOX free parking spot
      freeSpotSourceId: 'freeSpotSourceId',
      geoJsonSourceFreeSpot: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      freeSpotLayerId: 'freeSpotLayerId',
      geoJsonLayerFreeSpot: {
        id: 'freeSpotLayerId',
        type: 'circle',
        paint: {
          'circle-color': 'red',
          'circle-radius': {
            base: 1.75,
            stops: [
              [12, 2],
              [22, 180],
            ],
          },
        },
      },

      //MAPBOX free parking spot border
      freeSpotBorderLayerId: 'freeSpotBorderLayerId',
      geoJsonLayerFreeSpotBorder: {
        id: 'freeSpotBorderLayerId',
        type: 'circle',
        paint: {
          'circle-color': 'white',
          'circle-radius': {
            base: 1.6,
            stops: [
              [12, 2],
              [22, 180],
            ],
          },
        },
      },

      //MAPBOX line to destination
      lineSourceId: 'lineSourceId',
      geoJsonSourceLine: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      lineLayerId: 'lineLayerId',
      geoJsonLayerLine: {
        id: 'lineLayerId',
        type: 'line',
        paint: {
          'line-color': 'white',
          'line-width': 2,
          'line-dasharray': [2, 1],
        },
      },
    };
  },
  computed: {
    ...mapState('sites', ['current_site', 'current_parking', 'parkings', 'destinations', 'current_spot']),
    ...mapState('geoNotifPermissions', ['location', 'notificationPermission']),
  },
  watch: {
    current_site: function (newCurrentSite) {
      // Update map if current site is a new one selected
      if (newCurrentSite === undefined) {
        this.$router.push({ name: 'scene.sites.list' }).catch(() => {});
      }
      this.center = [this.current_site.location.lng, this.current_site.location.lat];
      this.zoom = this.current_site.zoom;
      this.$store.map.jumpTo({ zoom: this.zoom, center: this.center });
    },
    destinations: function (destinations) {
      //Update destinations on the map
      destinations.map(destination => {
        if (destination.fill_color !== undefined) {
          destination.geoJson.properties.fillcolor = destination.fill_color;
        }
        this.geoJsonSourceDestinations.data.features.push(destination.geoJson);
      });
      this.$store.map.getSource(this.destinationsSourceId).setData(this.geoJsonSourceDestinations.data);
    },
    parkings: function (parkings) {
      //Update parkings on the map
      parkings.map((parking, index) => {
        if (parking.fill_color !== undefined) {
          parking.geoJson.properties.fillcolor = parking.fill_color;
        }
        if (this.geoJsonSourceParkings.data.features[index] !== undefined) {
          this.geoJsonSourceParkings.data.features[index] = parking.geoJson;
        } else {
          this.geoJsonSourceParkings.data.features.push(parking.geoJson);
        }
        if (this.current_parking !== undefined && this.current_parking._id === parking._id) {
          this.setCurrentParking(parking);
          this.$store.map.setFeatureState({ source: this.parkingsSourceId, id: index }, { click: true });
        }
      });
      this.$store.map.getSource(this.parkingsSourceId).setData(this.geoJsonSourceParkings.data);
    },
    current_spot: function (spot) {
      //Update free spot on the map
      this.geoJsonSourceFreeSpot.data.features[0] = {
        id: 0,
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [spot.location.lng, spot.location.lat],
        },
      };
      this.$store.map.getSource(this.freeSpotSourceId).setData(this.geoJsonSourceFreeSpot.data);

      //update line bewteen spot and best pedestrian entry
      this.geoJsonSourceLine.data.features[0] = {
        id: 0,
        type: 'Feature',
        geometry: {
          type: 'LineString',
          properties: {},
          coordinates: [
            [spot.location.lng, spot.location.lat],
            [spot.best_pedestrian_exit.lng, spot.best_pedestrian_exit.lat],
          ],
        },
      };
      this.$store.map.getSource(this.lineSourceId).setData(this.geoJsonSourceLine.data);
      this.showLoading = false;
    },
  },
  async created() {},
  async mounted() {
    if (this.current_site === undefined || this.current_parking === undefined || this.location === undefined) {
      this.$router.push({ name: 'scene.sites.list' }).catch(() => {});
    }
  },
  methods: {
    ...mapActions('sites', {
      getById: 'getById',
      getParkings: 'getParkings',
      getDestinations: 'getDestinations',
      getNavigationSpot: 'getNavigationSpot',
      setCurrentParking: 'setCurrentParking',
      resetCurrentParking: 'resetCurrentParking',
    }),
    goBack() {
      this.$router.go(-2);
    },
    parkingSelected(event) {
      event.component.getSourceFeatures().forEach(feature => {
        let value = false;
        if (feature.id === event.mapboxEvent.features[0].id) {
          value = true;
          this.showLoading = true;
          this.setCurrentParking(this.parkings[event.mapboxEvent.features[0].id]);
          this.getNavigationSpot(this.location);
        }
        event.map.setFeatureState({ source: this.parkingsSourceId, id: feature.id }, { click: value });
      });
    },
    async onMapLoaded(event) {
      this.$store.map = event.map;
      await this.getById(this.current_site._id);
      await this.getDestinations(this.current_site._id);
      await this.getParkings(this.current_site._id);
      await this.getNavigationSpot(this.location);
      this.showLoading = false;

      let nbPictures = 0;
      if (this.current_site.local_logo) {
        this.addImageOnMap(event.map, this.current_site.local_logo, nbPictures);
        nbPictures += 1;
      }

      if (this.current_site.assets_pictures_map !== undefined) {
        this.current_site.assets_pictures_map.forEach(asset => {
          this.addImageOnMap(event.map, asset, nbPictures);
          nbPictures += 1;
        });
      }
    },

    addImageOnMap(map, img, index) {
      if (img && img.lat_top_left_corner && img.lng_top_left_corner && img.name && img.delta_lat && img.delta_lng) {
        map.addSource(`myImageSource${index}`, {
          type: 'image',
          url: `${Config.FRONT.PATH}/${img.name}`,
          coordinates: [
            [img.lng_top_left_corner, img.lat_top_left_corner + img.delta_lat],
            [img.lng_top_left_corner + img.delta_lng, img.lat_top_left_corner + img.delta_lat],
            [img.lng_top_left_corner + img.delta_lng, img.lat_top_left_corner],
            [img.lng_top_left_corner, img.lat_top_left_corner],
          ],
        });
        map.addLayer({
          id: `overlay${index}`,
          source: `myImageSource${index}`,
          type: 'raster',
          paint: {
            'raster-opacity': 1,
          },
        });
      }
    },
  },
};
</script>

<style></style>
